import { render, staticRenderFns } from "./Shopdetail.vue?vue&type=template&id=f9da40ba&scoped=true"
import script from "./Shopdetail.vue?vue&type=script&lang=js"
export * from "./Shopdetail.vue?vue&type=script&lang=js"
import style0 from "./Shopdetail.vue?vue&type=style&index=0&id=f9da40ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9da40ba",
  null
  
)

export default component.exports